import { render } from "./Logo.vue?vue&type=template&id=2484b8f5"
const script = {}
script.render = render

export default script